/*eslint-disable no-unused-vars */

import { ReactNode, useState } from 'react';
import cn from 'classnames';
import { ReactComponent as CaretSvg } from '@assets/svg/caret.svg';

import styles from './AccordionItem.module.scss';

export interface IAccordionProps {
  heading: string;
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  expanded?: boolean;
  withCaret?: boolean;
  className?: string;
}

export default function AccordionItem({ heading = '', children, className = '', expanded = false, withCaret = false, ...rest }: IAccordionProps): JSX.Element {
  const [open, setOpen] = useState(expanded);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div
      className={cn(styles.container, className, {
        [styles.withCaret]: withCaret,
      })}
    >
      <div className={cn(styles.item, { [styles.open]: open })} onClick={handleClick}>
        <span className={styles.heading}>{heading}</span>
        {withCaret && (
          <div className={styles.caret}>
            <CaretSvg />
          </div>
        )}
      </div>
      <div className={cn(styles.content, { [styles.open]: open })}>{children}</div>
    </div>
  );
}
